<template>
  <div>
    <div class="title">
      <span>项目名称：{{dataList[0].projectName}}</span>
      <span>门店：{{dataList[0].storeName}}</span>
      <span>岗位：{{dataList[0].posName}}</span>
    </div>
    <div class="title">
      {{Child.planNumber}}
      <div>
        <div>{{dataList[0].planNumber}}</div>
        <div>计划人数</div>
      </div>
      <div>
        <div>{{dataList[0].recruitsNumber}}</div>
        <div>招聘人数</div>
      </div>
      <div>
        <div v-if="dataList[0].waitNumber">{{dataList[0].waitNumber}}</div>
        <div v-else>0</div>
        <div>待审核人数</div>
      </div>
      <div>
        <div v-if="dataList[0].interviewPassNumber">{{dataList[0].interviewPassNumber}}</div>
        <div v-else>0</div>
        <div>审核通过人数</div>
      </div>

    </div>

    <div class="tableBody">
      <el-table class="limitManagerTable table-expand" style="width: 100%" :data="tableData" size="small"
                v-loading="listLoading" element-loading-text="拼命加载中..." border header-row-class-name="table-header">
        <el-table-column fixed="left" width="60" type="index" label="#" align="center"></el-table-column>
        <el-table-column width="100" prop="name" label="姓名" align="center"></el-table-column>
        <el-table-column width="100" prop="salesmanEmpPk" label="促销员ID" align="center"></el-table-column>
        <el-table-column width="100" prop="attendanceRate" label="考勤率" align="center"></el-table-column>
        <el-table-column width="150" prop="realNameAuthenticationTime" label="实名认证时间" align="center"></el-table-column>
        <el-table-column id="mask_box" width="110" prop="telEncrypt" label="联系电话" align="center" @click="createOutCall(scope.row.salesmanEmpPk, scope.row.name, scope.row.tel, '', dataList[0].projectCode, dataList[0].projectName)" >
          <template slot-scope="scope">
            <a href="##" id="mask_box" @click="createOutCall(scope.row.salesmanEmpPk, scope.row.name, scope.row.tel, '', dataList[0].projectCode, dataList[0].projectName)">{{scope.row.telEncrypt}}</a>
          </template>
        </el-table-column>
        <el-table-column width="200" prop="idCardEncrypt" label="身份证号码" align="center"></el-table-column>
        <el-table-column width="100" prop="applyTime" label="应聘时间" align="center"></el-table-column>
        <el-table-column width="160" label="操作时间" align="center">
          <template slot-scope="scope">
            <div>
              {{formatTime2(scope.row.updateTime)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" prop="stroeName" label="状态" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus == -1">该促销员为在岗状态</div>
            <div v-if="scope.row.auditStatus == 1">未审核</div>
            <div v-if="scope.row.auditStatus == 4">释放</div>
            <div v-if="scope.row.auditStatus == 5">审核不通过</div>
            <div v-if="scope.row.auditStatus == 6">审核通过</div>
            <div v-if="scope.row.auditStatus == 7">释放</div>

          </template>
        </el-table-column>
        <el-table-column width="100" prop="interviewerName" label="审核者" align="center"></el-table-column>
        <el-table-column width="100" prop="releaserName" label="释放者" align="center"></el-table-column>


        <el-table-column fixed="right" label="操作" width="160" align="center">
          <template slot-scope="scope">
            <div
                v-if="scope.row.auditStatus == 5  || scope.row.auditStatus == -1 ||(scope.row.auditStatus == 7 && scope.row.projectCategoryConfig != 'MNPG2202')">
              <el-button type="text" style="color:gray" size="small" disabled>——</el-button>
              <span class="cutLine"></span>
              <el-button type="text" style="color:gray" size="small" disabled>——</el-button>
            </div>
            <!-- releaseTrue(scope.row) -->
            <div v-if="scope.row.auditStatus == 6 && scope.row.releaseEnabled">
              <el-button type="text" size="small" @click="operation(scope.row,7,'释放')">释放</el-button>
            </div>
            <div v-if="scope.row.auditStatus == 1">
              <el-button type="text" size="small" @click="operation(scope.row,6,'审核通过')">审核通过</el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" @click="operation(scope.row,5,'审核不通过')">审核不通过</el-button>
            </div>
            <div v-if="scope.row.auditStatus == 7 && scope.row.projectCategoryConfig == 'MNPG2202'">
              <el-button type="text" size="small" @click="operation(scope.row,8,'重新录用')">重新录用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="width:60%;margin:0 auto;">
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize" :total="total" layout="total,prev, pager, next, jumper">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="释放处理" class="quitDialog dialog PromotersDialog" width="600px" :center="true" :show-close="false"
               :visible.sync="release" append-to-body :close-on-click-modal='false'>
      <div style="text-align:center">确认将该人员从此任务上释放吗？</div>
      <div style="text-align:center;margin-top:40px;">
        <el-button type="text" class="reset-btn" @click="changeRelease">取消</el-button>
        <el-button class="search-btn" @click="submitRelease">提交</el-button>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data() {
      return {
        total: null,
        pageNo: 1,
        pageSize: 10,
        //父级信息
        dataList: this.Child,
        //表单信息
        tableData: [],
        provinceId: null,
        listLoading: false,
        releaseInfo: null,
        release: false,
        radio: "8"
      };
    },
    props: ["Child"],
    mounted() {
      this.getData();
    },
    methods: {
      change() {
        this.$emit("upup", false); //主动触发父级upup方法，'hehe'为向父组件传递的数据
      },
      Refresh() {
        this.$emit("fresh"); //主动触发父级fresh方法，'hehe'为向父组件传递的数据
      },
      getNumber() {//刷新内部人数数据
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/searchPosStore",
          params: {
            postoreId: this.dataList[0].posStoreId,
          }
        }).then(res=>{
          let number = this.dataList[0]
          let data = res.data

          number.planNumber = data.planNumber;
          number.recruitsNumber = data.recruitsNumber;
          number.waitNumber = data.waitNumber;
          number.interviewNumber = data.interviewNumber;
          number.interviewPassNumber = data.interviewPassNumber;
        }).catch(err=>{
          this.$notify({
            title: "错误",
            message: '查询失败，请刷新重试',
            type: "error"
          });
        })
      },
      handleSizeChange(value) {
      },
      handleCurrentChange(value) {
        this.pageNo = value;
        this.getData();
      },
      searchCity(value) {
      },

      getData() {
        this.listLoading = true;
        this.$http({
          method: "GET",
          url: "/rest/PostManagement/searchAuditSalesman",
          params: {
            posStoreId: this.dataList[0].posStoreId,
            operatorId: sessionStorage.getItem("sysUserId"),
            pageNo: this.pageNo,
            pageSize: this.pageSize
          }
        }).then(res => {
          this.tableData = res.data;
          this.listLoading = false;
        }).catch(err => {
          this.listLoading = false;
        });

        this.$http({
          method: "GET",
          url: "/rest/PostManagement/countAuditSalesman",
          params: {
            posStoreId: this.dataList[0].posStoreId
          }
        }).then(res => {
          this.total = res.data;
        })
      },
      changeValue(i) {
        console.log(i);
      },
      operation(i, num, text) {
        var msg = '';
        if(num == 7){
          msg = '确认将该人员从此任务上释放吗？'
        }else if(num == 5){
          msg = '审核不通过之后，该人员将无法执行此任务，确认审核不通过吗？'
        }else{
         msg = `此操作不可撤销，确认${text} ？`
        }
        this.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var a = new Date().getTime();
          var arr = [
            {
              salesmanWorkApplyId: i.salesmanWorkApplyId,
              posStoreId: i.posStoreId,
              salesmanId: i.salesmanId,
              name: i.name,
              tel: String(i.tel),
              idCard: String(i.idCard),
              applyTime: i.applyTime,
              passTime: this.formatTime(a),
              auditStatus: num,
              operatorId: sessionStorage.getItem("sysUserId")
            }
          ];
          this.$http({
            method: "POST",
            url: "/rest/PostManagement/AuditSalesman",
            data: arr
          }).then(res => {
            console.log('rrrrrrrrrrrrrrrrrr' + res.data)
            let flg = false
            let message = res.data.message
            if (message == '成功') {
              flg = true
              this.$notify({
                title: "成功",
                message: "操作成功",
                type: "success"
              });
              this.Refresh()//刷新外部数据
            } else {
              //其他有多种情况，反正都是失败
              this.$notify({
                title: "警告",
                message: message,
                type: "warning"
              });
            }
            // 失败有时候也需要重载，干脆就全重载了，刷新外部那个太慢了，失败了不走
            this.getNumber()//刷新内部人数数据
            this.getData()//刷新内部table及count数据
            //只要是235就走，不管成功与否，但6必须是成功才走
            if(num == 2 || num == 3 ||num == 5 ||(num == 6 && flg)){
              this.$http({
                method: "POST",
                url:'/rest/PostManagement/sendMessage',
                params:{
                  salesmanId:i.salesmanId,
                  posName:this.dataList[0].posName,
                  auditStatus:num,
                  posStoreId:i.posStoreId
                }
              })
            }
          }).catch((err) => {
            console.log('eeeeeeeeeeeeeeeeeee' + err.response.data.message)
            let message = err.response.data.message
            this.$notify({
                title: "警告",
                message: message,
                type: "warning"
              });
        })
        })
      },
      formatTime(row, column, cellValue) {
        return moment(cellValue).format("YYYY-MM-DD");
      },
      formatTime2(val) {
        return moment(val).format("YYYY-MM-DD HH:mm:ss");
      },
      changeRelease() {
        this.release = false
      },
      releaseTrue(i) {
        this.releaseInfo = i
        this.release = true
      },
      submitRelease() {
        console.log(this.radio)
        this.operation(this.releaseInfo, 7, '释放')
        this.release = false
      },
      // 虚拟拨号
      createOutCall(salesmanId, salesmanName, salesmanTel, projectBU, projectCode, projectName) {
        // 获取当前用户虚拟电话配置
        this.$http({
          method: 'get',
          url: '/rest/JiangYiJoint/dummy-config',
          params: {
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          if(res.data.status == '200' && res.data.data) {
            let config = res.data.data;
            // 拨打虚拟电话
            var ajaxdata = {
              city: null,
              cityCode: null,
              county: null,
              countyCode: null,
              empPK: config.phoneUserEmpPk,
              module: "岗位管理",
              phoneUserCode: config.phoneUserCode,
              phoneUserName: config.phoneUserName,
              projectBU: projectBU,
              projectCode: projectCode,
              projectName: projectName,
              province: null,
              provinceCode: null,
              salesId: salesmanId,
              salesName: salesmanName,
              storeCode: null,
              storeName: null,
              ivr: {called: salesmanTel, caller: config.phoneNumber}
            }
            var xhrs2 = new XMLHttpRequest();
            xhrs2.onreadystatechange = function () {
              if (xhrs2.readyState == 4) {
                if (xhrs2.status == 200) {
                  // 成功不做任何事
                  document.getElementById('mask_box').disabled = true;
                  setTimeout(function () {
                    document.getElementById('mask_box').disabled = false;
                  }, 5000);
                  alert("号码呼叫中....");
                } else {
                  var str = JSON.parse(xhrs2.responseText);
                  document.getElementById('mask_box').disabled = true;
                  setTimeout(function () {
                    document.getElementById('mask_box').disabled = false;
                  }, 5000);
                  alert(str.msg);
                }
              }
            }
            var callurl = this.globalParams.remotesUrl + "/plugs/phoneCall/createOutCall";
            xhrs2.open('POST', callurl, true);
            xhrs2.setRequestHeader("Content-type", "application/json");
            xhrs2.send(JSON.stringify(ajaxdata));
          } else {
            alert("当前账号未配置虚拟拨号");
            console.log(res.data);
          }
        }).catch(err => {
          console.log(err);
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .title > span {
    font-size: 16px;
    color: black;
    margin-right: 30px;
  }

  .title:nth-child(2) {
    text-align: right;
    margin-top: 10px;
  }

  .title:nth-child(2) > div {
    // text-align: right;
    display: inline-block;
    text-align: center;
    margin-right: 30px;
  }

  .title:nth-child(2) > div > div:first-child {
    color: #2e2d79;
    font-size: 16px;
    font-weight: 900;
  }

  .tableBody {
    background-color: #f4f4f4;
    padding: 10px;
  }

  .cutLine {
    border-right: 1px solid #82bc82;
    margin: 0 10px;
    position: relative;
    right: 1px;
  }

  .PromotersDialog {
    margin-top: 10vh;
  }
</style>



// WEBPACK FOOTER //
// src/views/workSquare/handleApply.vue